import { Component } from 'react';

// Rete di sicurezza dell'intero albero React. Prima non esisteva: un errore di
// render in una qualunque pagina svuotava il DOM e lasciava una schermata
// bianca, senza modo di tornare indietro se non riscrivendo l'URL a mano.
//
// Sta **fuori** da LangProvider e da BrowserRouter apposta, per intercettare
// anche gli errori dei provider stessi. Per questo non usa `useLang` (un class
// component non puo' usare hook, e comunque il provider potrebbe essere proprio
// il pezzo rotto) e legge la lingua da <html lang>, che i18n.js tiene
// aggiornato. Per lo stesso motivo il ritorno alla home e' un <a> e non un
// <Link>: un reload vero riparte da zero, mentre una navigazione client
// rimonterebbe l'albero appena andato in errore.

const TESTI = {
  it: {
    titolo: 'Qualcosa è andato storto',
    corpo: 'La pagina non è riuscita a caricarsi. Riprova, oppure torna alla home.',
    riprova: 'Ricarica la pagina',
    home: 'Torna alla home',
  },
  en: {
    titolo: 'Something went wrong',
    corpo: 'This page failed to load. Try again, or go back to the homepage.',
    riprova: 'Reload the page',
    home: 'Back to homepage',
  },
};

export class ErrorBoundary extends Component {
  state = { errore: false };

  static getDerivedStateFromError() {
    return { errore: true };
  }

  componentDidCatch(errore, info) {
    console.error('[ErrorBoundary]', errore, info);
  }

  render() {
    if (!this.state.errore) return this.props.children;

    const lingua = typeof document !== 'undefined' && document.documentElement.lang === 'en'
      ? 'en'
      : 'it';
    const t = TESTI[lingua];

    return (
      <main
        className="grana flex min-h-[100dvh] items-center justify-center bg-carta px-6 py-24 text-center"
        data-testid="error-boundary"
      >
        <div className="max-w-lg">
          <h1 className="font-display text-3xl text-inchiostro md:text-4xl">{t.titolo}</h1>
          <p className="mt-4 text-[15px] leading-relaxed text-inchiostro/70">{t.corpo}</p>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="inline-flex min-h-[44px] items-center bg-inchiostro px-6 py-3 text-[14px] font-semibold text-carta transition-colors hover:bg-marsala"
              data-testid="error-boundary-reload"
            >
              {t.riprova}
            </button>
            <a
              href="/"
              className="inline-flex min-h-[44px] items-center border border-inchiostro/60 px-6 py-3 text-[14px] font-semibold text-inchiostro transition-colors hover:border-inchiostro"
              data-testid="error-boundary-home"
            >
              {t.home}
            </a>
          </div>
        </div>
      </main>
    );
  }
}
